import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import env from '@/env';

if (env.HAP_APP_INSIGHTS_CONN_STRING && env.HAP_APP_INSIGHTS_CONN_STRING !== '') {
  const appInsights = new ApplicationInsights({
    config: {
      connectionString: env.HAP_APP_INSIGHTS_CONN_STRING,
    },
  });
  appInsights.loadAppInsights();
  appInsights.trackPageView();
}
